export const fieldTypes = ["text", "textarea", "colors", "number", "date", "productLink", "fieldset", "checkbox", "list", "table", "media", "listcascade"];
